import { Gray, White } from '@constants/color';
import { css } from '@emotion/react';

export const rootContainer = css({
  display: 'flex',
  flexDirection: 'row'
});

export const mainContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '120px',
  width: '1152px',
  height: '952px',
  padding: '64px'
});
export const mainTopContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '40px'
});
export const mainContentContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '48px',
  padding: '0px 40px'
});
export const mainContentTopContainer = css({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '40px'
});
export const mainContentCenterContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '112px'
});

export const name = css({
  color: White.White10,
  fontSize: '48px',
  fontWeight: 700
});

export const row = css({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '48px'
});
export const column = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '12px'
});
export const title = css({
  color: Gray.Gray50,
  fontSize: '20px'
});
export const content = css({
  color: White.White10,
  fontSize: '24px',
  fontWeight: 700
});

export const rightContainer = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  rowGap: '20px',
  padding: '180px 64px',
  width: '512px',
  backgroundColor: Gray.Gray90
});

export const description = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: White.White10,
  fontSize: '36px',
  fontWeight: 700
});
